<template>
  <i class="fa fa-fw fa-upload"></i>
</template>

<script>
export default {
  name: 'Import',
};
</script>
<style scoped>
.fa-upload {
  color: #2993cf;
}
</style>



// WEBPACK FOOTER //
// ImportIcon.vue?e266d838